import * as React from 'react';

interface Props {
  checks: { [key: string]: boolean };
  allowButton: boolean;
  handleChange: (key: string) => (value: boolean) => void;
  handleClick: (value: string) => void;
}

const InvestorDeckStep1Component: React.StatelessComponent<Props> = (props: Props) => (
  <div className="tab-content padding-40">
    <h4><strong>¿Estás preparado para levantar capital en The Crowd Angel?</strong></h4>
    <p className="invest-subtitle">
      Por favor, dedica unos minutos a contestar estas preguntas que te ayudarán a saber si tu empresa cumple con las
      condiciones básicas para iniciar el proceso de análisis y poder conseguir financiación:
    </p>
    <strong className="number-points">1.-</strong>
    <strong className="padding-left-20 invest-subtitle">¿Tu empresa está registrada?</strong>
    <div className="row">
      <p className="col-md-10" style={{ paddingLeft: '55px' }}>
        No invertimos en ideas ni operaciones, invertimos en empresas. Para que podamos hacer la
          inversión, necesitaremos que tu empresa esté registrada y tengas ya el CIF.
      </p>
      <div className="checkbox col-md-2 text-center">
        <input
          type="checkbox"
          checked={props.checks.check1}
        />
        <label
          onClick={() => props.handleChange('check1')(!props.checks.check1)}
        />
      </div>
    </div>

    <strong className="number-points">2.-</strong>
    <strong className="padding-left-20 invest-subtitle">¿Tu empresa tiene "perfil startup"?</strong>
    <div className="row">
      <p className="col-md-10" style={{ paddingLeft: '55px' }}>
        No es necesario que seas una empresa tecnológica, pero sí que tengas un modelo de negocio altamente escalable
        que pueda multiplicar el valor de la empresa de manera significativa en los próximos 5 años. Un ejemplo de lo
        que NO son "perfiles startup" son agencias, consultoras, restauración, etc.
      </p>
      <div className="checkbox col-md-2 text-center">
        <input
          type="checkbox"
          checked={props.checks.check2}
        />
        <label
          onClick={() => props.handleChange('check2')(!props.checks.check2)}
        />
      </div>
    </div>

    <strong className="number-points">3.-</strong>
    <strong className="padding-left-20 invest-subtitle">
      ¿Tienes un producto/servicio que ya se ha lanzado al mercado y como mínimo lleva 6 meses facturando?
    </strong>
    <div className="row">
      <p className="col-md-10" style={{ paddingLeft: '55px' }}>
        Nuestra inversión no va destinada al lanzamiento de productos al mercado, ni tampoco invertimos en empresas
        que aún no están vendiendo. Buscamos startups con un producto o servicio ya lanzado al mercado y como mínimo
        seis meses de métricas que prueben el modelo y la traccción; y que el dinero de la inversión sirva para acelerar
        este crecimiento inicial.
      </p>
      <div className="checkbox col-md-2 text-center">
        <input
          type="checkbox"
          checked={props.checks.check3}
        />
        <label
          onClick={() => props.handleChange('check3')(!props.checks.check3)}
        />
      </div>
    </div>

    <strong className="number-points">4.-</strong>
    <strong className="padding-left-20 invest-subtitle">
      ¿Tienes un equipo inicial montado?
    </strong>
    <div className="row">
      <p className="col-md-10" style={{ paddingLeft: '55px' }}>
        Las startups las gestionan equipos, y son un elemento clave de su potencial éxito. No invertimos en empresas de
        una o dos personas, sino que esperamos ver que tienes ya un equipo inicial comprometido.
      </p>
      <div className="checkbox col-md-2 text-center">
        <input
          type="checkbox"
          checked={props.checks.check4}
        />
        <label
          onClick={() => props.handleChange('check4')(!props.checks.check4)}
        />
      </div>
    </div>

    <strong className="number-points">5.-</strong>
    <strong className="padding-left-20 invest-subtitle">
      ¿El capital que necesitas en este momento es como mínimo de 150.000€?
    </strong>
    <div className="row">
      <p className="col-md-10" style={{ paddingLeft: '55px' }}>
        Nuestro ticket mínimo de inversión es de 150.000€. Si tu necesidad financiera es menor que 150.000 €,
        probablemente aún no estás en el momento adecuado para buscar financiación con nosotros.
      </p>
      <div className="checkbox col-md-2 text-center">
        <input
          type="checkbox"
          checked={props.checks.check5}
        />
        <label
          onClick={() => props.handleChange('check5')(!props.checks.check5)}
        />
      </div>
    </div>

    <strong className="number-points">6.-</strong>
    <strong className="padding-left-20 invest-subtitle">
      ¿Tienes una presentación de tu empresa en formato "investor deck" preparada?
    </strong>
    <div className="row">
      <p className="col-md-10" style={{ paddingLeft: '55px' }}>
        Si cumples con todos los requisitos anteriores, el primer paso del proceso de análisis consistirá en que nos
        mandes una presentación de tu empresa en formato "investor deck".
      </p>

      <div className="checkbox col-md-2 text-center">
        <input
          type="checkbox"
          checked={props.checks.check6}
        />
        <label
          onClick={() => props.handleChange('check6')(!props.checks.check6)}
        />
      </div>
    </div>
    <div className="row">
      <div className="gap-10" />
      <p className="col-md-10" style={{ paddingLeft: '55px', textDecoration: 'underline' }}>
        <a
          href="https://guykawasaki.com/the-only-10-slides-you-need-in-your-pitch/"
          target="_blank"
        >
          En este enlace puedes ver a que nos referimos cuando hablamos de “investor deck”.
        </a>
      </p>
    </div>
    <div className="gap-20" />
    <p className="text-center">
      <button
        className="btn btn-secondary send-investor-deck-button"
        onClick={() => props.handleClick('investorDeck')}
        disabled={props.allowButton}
      >
        Enviar el investor deck
      </button>
    </p>
  </div>
);

export default InvestorDeckStep1Component;



// WEBPACK FOOTER //
// ./src/modules/investor-deck/partials/InvestorDeckStep1.component.tsx